import { imagexConfig } from 'UTILS'

export default function getUrlByPath(path: string) {
  return `${imagexConfig.domain}/${path}.image`
}
